/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  GetMetaMcpServerRequest,
  GetMetaMcpServerSecurity,
} from "../models/operations/getmetamcpserver.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildGetMetaMcpServerQuery,
  GetMetaMcpServerQueryData,
  prefetchGetMetaMcpServer,
  queryKeyGetMetaMcpServer,
} from "./getMetaMcpServer.core.js";
export {
  buildGetMetaMcpServerQuery,
  type GetMetaMcpServerQueryData,
  prefetchGetMetaMcpServer,
  queryKeyGetMetaMcpServer,
};

export type GetMetaMcpServerQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * getMetaMcpServer metaMcp
 *
 * @remarks
 * Get a meta MCP server by id
 */
export function useGetMetaMcpServer(
  request: GetMetaMcpServerRequest,
  security?: GetMetaMcpServerSecurity | undefined,
  options?: QueryHookOptions<
    GetMetaMcpServerQueryData,
    GetMetaMcpServerQueryError
  >,
): UseQueryResult<GetMetaMcpServerQueryData, GetMetaMcpServerQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildGetMetaMcpServerQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * getMetaMcpServer metaMcp
 *
 * @remarks
 * Get a meta MCP server by id
 */
export function useGetMetaMcpServerSuspense(
  request: GetMetaMcpServerRequest,
  security?: GetMetaMcpServerSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    GetMetaMcpServerQueryData,
    GetMetaMcpServerQueryError
  >,
): UseSuspenseQueryResult<
  GetMetaMcpServerQueryData,
  GetMetaMcpServerQueryError
> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildGetMetaMcpServerQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setGetMetaMcpServerData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      id: string;
      gramSession?: string | undefined;
      gramKey?: string | undefined;
      gramProject?: string | undefined;
    },
  ],
  data: GetMetaMcpServerQueryData,
): GetMetaMcpServerQueryData | undefined {
  const key = queryKeyGetMetaMcpServer(...queryKeyBase);

  return client.setQueryData<GetMetaMcpServerQueryData>(key, data);
}

export function invalidateGetMetaMcpServer(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      id: string;
      gramSession?: string | undefined;
      gramKey?: string | undefined;
      gramProject?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "metaMcp", "get", ...queryKeyBase],
  });
}

export function invalidateAllGetMetaMcpServer(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "metaMcp", "get"],
  });
}
